import { UserRole } from "../../user/enums/UserRole";
import { useAuth } from "../../auth/hooks/useAuth";
import { useQuery } from "react-query";
import useUserQueries from "../../user/hooks/useUserQueries";
import { useLocation } from "react-router";

export const useServiceProviderId = (): string => {
  const {
    user,
    profile: { data: { data: profile = null } = {} },
  } = useAuth();
  const { fetchUserProfile } = useUserQueries();
  const { pathname } = useLocation();

  const isAdminOrSupport = [
    UserRole.Owner,
    UserRole.Admin,
    UserRole.Support,
  ].includes(user.role);
  const userIdFromPath = pathname.split("user/")[1]?.split("/")[0];

  const userId = isAdminOrSupport ? userIdFromPath : user.id;

  const { data: serviceProviderProfile } = useQuery<any>(
    `profile_${userId}`,
    () => fetchUserProfile(userId),
    { enabled: isAdminOrSupport && userIdFromPath },
  );

  let serviceProviderId;

  if (user.role === UserRole.ServiceProvider) {
    serviceProviderId = profile.serviceProvider.id;
  } else if (isAdminOrSupport) {
    serviceProviderId = serviceProviderProfile?.data?.serviceProvider.id;
  }

  return serviceProviderId;
};
